import { inject, InjectionToken, signal, WritableSignal } from '@angular/core';
import { RosterFeatureRegistry } from '@softapps/pms/roster-core';

const ROSTER_FEATURE_NAME = new InjectionToken<WritableSignal<string | null>>(
  'ROSTER_FEATURE_NAME',
  {
    factory: () => signal(null),
  }
);

export const rosterRoutes = [
  {
    path: 'roster/:featureName',
    canActivate: [
      (route) => {
        const name = inject(ROSTER_FEATURE_NAME);
        const nameFromRouteParam = route.paramMap.get('featureName');
        if (nameFromRouteParam) name.set(nameFromRouteParam);
        return true;
      },
    ],
    canDeactivate: [
      () => {
        inject(ROSTER_FEATURE_NAME).set(null);
        return true;
      },
    ],
    loadComponent: () => {
      /**
       * The extra step with a custom injection token is required in order to get the current feature name
       * Reason: Accessing ActivatedRoute in loadComponent returns null
       */
      const featureName = inject(ROSTER_FEATURE_NAME)();

      if (!featureName) return import('./pages/roster.component');

      const feature = inject(RosterFeatureRegistry).get(featureName);

      return feature?.departmentHeadRequired === false
        ? import('./pages/roster-no-department-head/roster-no-department-head')
        : import('./pages/roster.component');
    },
  },
];
